import { http } from './http';

class Installations {
  getMy() {
    return http.get('/installations/my');
  }
}

export const installations = new Installations();
